import _orderBy from "lodash/orderBy";
import store from "@/store/index";

export function normalizeOrder(order) {
  if (!order) order = {};
  if (!order.path) order.path = "name";
  if (typeof order.path === "string") order.path = [order.path];

  return order;
}

export function _order(items, order) {
  if (items) {
    order = normalizeOrder({ ...order });
    return _orderBy([...items], order.path, [order.reversed ? "desc" : "asc"]);
  } else return [];
}

export function getReversed(stateOrder, order) {
  order = normalizeOrder(order);
  stateOrder = normalizeOrder(stateOrder);

  if (
    hasMultiple(order.path) &&
    hasSame(stateOrder.path, order.path) &&
    !stateOrder.reversed
  ) {
    if (getValue(stateOrder.path) === getValue(order.path)) {
      order.path = order.path.reverse();
    } else if (getValue(stateOrder.path) !== getValue(order.path)) {
      order.reversed = !stateOrder.reversed;
    }

    return order;
  } else if (getValue(stateOrder.path) === getValue(order.path)) {
    order.reversed = !stateOrder.reversed;
    return order;
  } else return order;
}

function hasSame(obj, obj2) {
  return obj.filter((x) => obj2.some((y) => y === x)).length === obj.length;
}

function hasMultiple(obj) {
  return typeof obj === "object" && obj.length > 1;
}

function getValue(obj) {
  if (typeof obj === "object") return obj[0];
  else return obj;
}

export function dispatchDomainOrder(path, reversed) {
  store.dispatch("domain/order", {
    path: path,
    reversed: !!reversed,
  });
}

export function dispatchSourceOrder(path, reversed) {
  store.dispatch("source/order", {
    path: path,
    reversed: !!reversed,
  });
}

export function dispatchComputerOrder(path, reversed) {
  store.dispatch("computer/order", {
    path: path,
    reversed: !!reversed,
  });
}

export function dispatchGroupOrder(path, reversed) {
  store.dispatch("group/order", {
    path: path,
    reversed: !!reversed,
  });
}
